import React, { useEffect, useState } from 'react'
import AccordionComp from 'components/accordion/Accordion'
import Button from 'components/formElements/Button'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import Loading from 'components/loader/Loading'
import * as FileSaver from 'file-saver'

const PmPlanReport = () => {
	const [getProjects, loading] = useRequest()
	const [report, setReport] = useState([])
	const [reportSummary, setReportSummary] = useState([])
	//const { showToast } = useToast()
	//const [loading, setLoading] = useState(false)
	const [week, setWeek] = useState(4)

	useEffect(() => {
		handleSubmit()
	}, [])
	
	useEffect(() => {
		getProjects('/Project/ReportSummary', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setReportSummary(res.data.result)
			}
		})
	}, [])

	const exportExcel = () => {
		const newArray = report.map((item) => {
			const rest = {
				'Proje Yöneticisi': item.pmName,
				'Proje Adı': item.projectName,
				'Planlanan Gün': item.plannedDay,
				'Proje Durumu': item.projectStatuses,
				Jira: item.issuesSummary,
			}
			return rest
		})
		import('xlsx').then((xlsx) => {
			const workSheet = xlsx.utils.json_to_sheet(newArray)
			const workBook = { Sheets: { data: workSheet }, SheetNames: ['data'] }
			const excelBuffer = xlsx.write(workBook, {
				bookType: 'xlsx',
				type: 'array',
			})
			saveAsExcelFile(excelBuffer, 'pmPlanReport')
		})
	}

	const exportSummaryExcel = () => {
		const summaryExcelData = reportSummary.map((item) => {
			return {
				'PM': item.pmName,
				'Turnkey': item.turnkeyProjectCount,
				'SLA': item.slaProjectCount,
				'CR': item.crProjectCount,
				'Toplam': item.totalProjectCount,
			}
		})
		import('xlsx').then((xlsx) => {
			const workSheetSummary = xlsx.utils.json_to_sheet(summaryExcelData)
			const workBookSummary = { Sheets: { data: workSheetSummary }, SheetNames: ['data'] }
			const excelBufferSummary = xlsx.write(workBookSummary, {
				bookType: 'xlsx',
				type: 'array',
			})
			saveAsExcelFile(excelBufferSummary, 'pmPlanReportSummary')
		})
	}

	const saveAsExcelFile = (buffer, fileName) => {
		let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
		let EXCEL_EXTENSION = '.xlsx'
		const data = new Blob([buffer], {
			type: EXCEL_TYPE,
		})
		FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
	}

	const rowBodyTemplate = (data) => {
		return {
			'bg-gray': data.isProjectArchived == true,
			turnKeyCond: data.turnKeyCondition == true,
		}
	}

	const rowBodyTemplateForJiraCol = (data) => {
		return {
			turnKeyCond: data.turnKeyCondition == true,
			'bg-gray': data.isProjectArchived == true,
			jiraColRed: data.isJiraEmpty == true && data.plannedDay > 0,
		}
	}
	const handleSubmit = () => {
		getProjects('/Project/Report', { method: 'POST', data: { week: week } }).then((res) => {
			if (res.data.ok) {
				setReport(
					res.data.result?.sort(function (a, b) {
						return a.pmName.localeCompare(b.pmName)
					})
				)
			}
		})
	}
	return (
		<AnimatedSpan className='page-container d-flex flex-column gap-4'>
			<div className='card'>
				<div className='row-margin-x'>
					<div className='col-md-6'>
						<div className='row'>
							<div className='col-md-2'>
								Hafta
								<input
									placeholder='Hafta'
									className='default-input'
									type='number'
									name='week'
									defaultValue={4}
									onChange={(e) => setWeek(e.target.value)}
								/>
							</div>
							<div className='col-md-2 mt-3'>
								<Button disabled={loading} title='Raporu Al' handleClick={handleSubmit} className='btn-primary w-100 d-flex justify-content-center' />
							</div>
							<div className='col-md-3 mt-3'>
								<Button disabled={loading} title='Plan Raporu Excel' handleClick={exportExcel} className='btn-success w-100 d-flex justify-content-center' />
							</div>
							<div className='col-md-3 mt-3'>
								<Button disabled={loading} title='Plan Özeti Excel' handleClick={exportSummaryExcel} className='btn-success w-100 d-flex justify-content-center' />
							</div>
						</div>
					</div>
				</div>
			</div>
			{report.length == 0 && reportSummary.length == 0 && !loading && (
				<div className='card'>
					<div className='text-sm text-semi-bold'>Gösterilecek Bir Veri Bulunmuyor</div>
				</div>
			)}
			{loading && (
				<div className='d-flex w-100 justify-content-center'>
					<Loading size={24} />
				</div>
			)}
			<div className='row'>
				{reportSummary.length > 0 && (
					<AccordionComp className='report-accordion col-md-12' showHideTitle={false} onVal={false} title='Rapor Özeti'>
						<div className='row-margin-x'>
							<div className='col-md-12'>
								<DataTable
									emptyMessage='Hiç Kayıt Bulunamadı'
									responsiveLayout='stack'
									loading={loading}
									value={reportSummary}
									sortField='pmName'
									sortOrder={1}
								>
									<Column
										sortable
										className='text-semi-bold text-bold '
										headerClassName='text-bold bg-primary text-default'
										field='pmName'
										style={{ width: 'auto' }}
										header='PM'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='turnkeyProjectCount'
										style={{ width: 'auto' }}
										header='Turnkey'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='slaProjectCount'
										style={{ width: 'auto' }}
										header='SLA'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='crProjectCount'
										style={{ width: 'auto' }}
										header='CR'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='totalProjectCount'
										style={{ width: 'auto' }}
										header='Toplam'
									/>
								</DataTable>
							</div>
						</div>
					</AccordionComp>
				)}
			</div>
			<div className='row'>
				{report.length > 0 && (
					<AccordionComp className='report-accordion col-md-12' showHideTitle={false} onVal={false} title='PM Plan Raporu'>
						<div className='row-margin-x'>
							<div className='col-md-12'>
								<DataTable
									emptyMessage='Hiç Kayıt Bulunamadı'
									responsiveLayout='stack'
									loading={loading}
									rowGroupMode='rowspan'
									groupRowsBy='pmName'
									value={report}
									style={{ lineHeight: '5px' }}
									sortField='pm' // Developer alanına göre sıralama yapılıyor
									sortOrder={1} // Artan sıralama için 1, azalan sıralama için -1
								>
									<Column
										sortable
										className='text-semi-bold text-bold '
										headerClassName='text-bold bg-primary text-default'
										field='pmName'
										style={{ width: 'auto' }}
										header='PM'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm '
										headerClassName='text-bold bg-primary text-default'
										field='projectName'
										style={{ width: 'auto' }}
										header='Proje'
										bodyClassName={rowBodyTemplate}
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='plannedDay'
										style={{ width: 'auto' }}
										header='Planlanan Gün'
										bodyClassName={rowBodyTemplate}
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='projectStatuses'
										style={{ width: 'auto' }}
										header='Proje Durumu'
										bodyClassName={rowBodyTemplate}
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='issuesSummary'
										style={{ width: 'auto' }}
										header='Jira'
										body={(rowData) => {
											return (
												<span>
													<a
														style={
															rowData.isJiraEmpty == true && rowData.plannedDay > 0
																? { cursor: 'pointer', color: '#750505' }
																: rowData.isJiraEmpty == true && rowData.plannedDay > 0 && rowData.isProjectArchived
																? { cursor: 'pointer', color: '#750505', backgroundColor: '#EEEEEE' }
																: rowData.turnKeyCondition
																? { cursor: 'pointer', backgroundColor: '#B0D9BA' }
																: { cursor: 'pointer' }
														}
														target='_blank'
														onClick={() => {
															var otherWindow = window.open()
															otherWindow.opener = null
															otherWindow.location = 'https://nuevosoftware.atlassian.net/jira/software/c/projects/' + rowData.jiraKey + '/list'
														}}
													>
														{rowData.issuesSummary}
													</a>
												</span>
											)
										}}
										bodyClassName={rowBodyTemplateForJiraCol}
									/>
								</DataTable>
							</div>
						</div>
					</AccordionComp>
				)}
			</div>
		</AnimatedSpan>
	)
}

export default PmPlanReport
